<template>
    <b-modal :active="active" has-modal-card trap-focus aria-role="dialog" aria-modal @update:active="fechar">
        <div class="modal-card prd-notification-modal">
            <header class="modal-card-head">
                <div>
                    <p class="modal-card-title">Notificações</p>
                    <p class="is-size-7 has-text-grey">Atualizações que pedem sua atenção</p>
                </div>                
            </header>

            <section class="modal-card-body">
                <b-loading :active="carregando" :is-full-page="false" />
                <prd-empty-state
                    v-if="!carregando && notificacoes.length === 0"
                    icon="bell-sleep-outline"
                    title="Tudo em dia"
                    description="Você não possui notificações."
                />
                <div v-else class="prd-notification-list">
                    <article v-for="item in notificacoes" :key="item.id" class="prd-notification-item" :class="{ unread: !item.lida }">
                        <div class="prd-notification-icon"><b-icon :icon="icone(item)" /></div>
                        <div class="prd-notification-content">
                            <div class="prd-notification-title">
                                <strong>{{ item.titulo || 'Notificação' }}</strong>
                                <span v-if="!item.lida" class="prd-unread-dot" title="Não lida" />
                            </div>
                            <p>{{ item.mensagem || 'Sem detalhes adicionais.' }}</p>
                            <small>{{ data(item.dataHoraCadastro) }}</small>
                        </div>
                        <div class="prd-notification-actions">
                            <b-button
                                v-if="item.orcamentoId"
                                size="is-small"
                                type="is-light"
                                icon-left="open-in-new"
                                title="Abrir registro"
                                @click="abrirRegistro(item)"
                            />
                            <b-button
                                v-if="!item.lida"
                                size="is-small"
                                type="is-primary is-light"
                                icon-left="check"
                                :loading="marcandoId === item.id"
                                @click="marcarLida(item)"
                            >
                                Marcar como lida
                            </b-button>
                        </div>
                    </article>
                </div>
            </section>
        </div>
    </b-modal>
</template>

<script>
import http from '@/http'
import { mapGetters } from 'vuex'
import prdEmptyState from '@/components/prd/prdEmptyState.vue'

export default {
    name: 'PrdNotificacoesModal',
    components: { prdEmptyState },
    props: {
        active: Boolean,
        unidadeId: { type: Number, default: null },
    },
    data() {
        return {
            carregando: false,
            marcandoId: null,
            notificacoes: [],
        }
    },
    computed: { ...mapGetters(['isInRole']) },
    watch: {
        active(valor) {
            if (valor) this.carregar()
        },
        unidadeId() {
            if (this.active) this.carregar()
        },
    },
    methods: {
        async carregar() {
            if (!this.unidadeId) {
                this.notificacoes = []
                this.emitirTotal()
                return
            }
            this.carregando = true
            try {
                const res = await http.get(`/api/prd/dashboard/notificacoes?unidadeId=${this.unidadeId}&somenteNaoLidas=true`)
                this.notificacoes = res.data || []
                this.emitirTotal()
            } catch (e) {
                this.erro(e)
            } finally {
                this.carregando = false
            }
        },
        async marcarLida(item) {
            this.marcandoId = item.id
            try {
                await http.post(`/api/prd/dashboard/notificacoes/${item.id}/lida?unidadeId=${this.unidadeId}`)
                this.notificacoes = this.notificacoes.filter((notificacao) => notificacao.id !== item.id)
                this.emitirTotal()
            } catch (e) {
                this.erro(e)
            } finally {
                this.marcandoId = null
            }
        },
        abrirRegistro(item) {
            const podeAnalisar = this.isInRole('prd-analise-consultar') || this.isInRole('prd-analise-alterar')
            const podeProduzir = this.isInRole('prd-pedidos-consultar') || this.isInRole('prd-pedidos-produzir') || this.isInRole('prd-pedidos-entregar')
            const nome = item.tipo === 1 && podeAnalisar ? 'prd-analise-detalhe'
                : [8, 9, 10].includes(item.tipo) && podeProduzir ? 'prd-producao-detalhe' : 'prd-orcamento'
            const rota = { name: nome, params: { id: item.orcamentoId } }
            this.fechar(false)
            this.$router.push(rota)
        },
        emitirTotal() {
            this.$emit('total-atualizado', this.notificacoes.filter((item) => !item.lida).length)
        },
        fechar(valor) {
            this.$emit('update:active', Boolean(valor))
        },
        icone(item) {
            return [1, 8, 9, 10].includes(item.tipo) ? 'factory' : 'file-document-outline'
        },
        data(v) {
            return v ? new Date(v).toLocaleString('pt-BR') : ''
        },
        erro(e) {
            this.$buefy.toast.open({ message: e.data?.erro || 'Não foi possível carregar as notificações.', type: 'is-danger' })
        },
    },
}
</script>

<style scoped>
.prd-notification-modal {
    width: min(720px, calc(100vw - 2rem));
}
.modal-card-body {
    position: relative;
    min-height: 180px;
    padding: 0;
}
.prd-notification-list {
    display: grid;
}
.prd-notification-item {
    display: flex;
    align-items: flex-start;
    gap: 0.8rem;
    padding: 1rem 1.2rem;
    border-bottom: 1px solid #edf0f4;
}
.prd-notification-item:last-child {
    border-bottom: 0;
}
.prd-notification-item.unread {
    background: #f2f8ff;
}
.prd-notification-icon {
    flex: 0 0 38px;
    height: 38px;
    display: grid;
    place-items: center;
    border-radius: 10px;
    background: var(--brand-teal-100);
    color: var(--brand-teal-600);
}
.prd-notification-content {
    flex: 1;
    min-width: 0;
}
.prd-notification-title {
    display: flex;
    align-items: center;
    gap: 0.45rem;
}
.prd-unread-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #3273dc;
}
.prd-notification-content p {
    margin-top: 0.15rem;
    color: #52606d;
}
.prd-notification-content small {
    display: block;
    margin-top: 0.25rem;
    color: #8492a6;
}
.prd-notification-actions {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}
@media (max-width: 600px) {
    .prd-notification-item {
        flex-wrap: wrap;
    }
    .prd-notification-actions {
        width: 100%;
        justify-content: flex-end;
        padding-left: 46px;
    }
}
</style>
